import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AmplitudeApiService {

  constructor(private http:HttpClient) { }

  logEvent(eventObj: any):Observable<any>{
    return this.http.post<any>('/api/amplitude', eventObj);
  }
}
